const PATH = "/api/v1/activity";

const ENDPOINTS = {
  WEBAPP_ESCAPE: "/escape/",
  WEBAPP_ESCAPE_DESTINATIONS: "/escape/destinations/",
  WEBAPP_ESCAPE_REVIEWS: "/escape/reviews/",
};

export type ActivityEndpoints = keyof typeof ENDPOINTS;
export const ActivityCollection = { PATH, ENDPOINTS };
